export default [
  { name: '北士科願景', imgSrc: '', subTitle: '', section: 'sec3', svgSrc: '', offset: -250 },
  { name: '地球村生活', imgSrc: '', subTitle: '', section: 'sec4', svgSrc: '', offset: -150 },
  { name: '雙園靜謐居', imgSrc: '', subTitle: '', section: 'sec5', svgSrc: '', offset: -150 },
  { name: '高坪效精品', imgSrc: '', subTitle: '', section: 'sec6', svgSrc: '', offset: -170 },
  { name: '宏普品牌學', imgSrc: '', subTitle: '', section: 'sec7', svgSrc: '', offset: -150 },
]
